import { usePitcher } from "features/utils/usePitcher";

import { useAnalytics } from "hooks/useAnalytics";
import { useVSCodeExtensionInitializedEffect } from "hooks/useVSCodeExtensionInitializedEffect";
import { executeVSCodeCommand } from "utils/vscode";

const SANDBOX_CONFIG_FILE = "sandbox.config.json";

export const AutoOpenTestRunnerDevtool = () => {
  const pitcher = usePitcher();
  const track = useAnalytics();

  useVSCodeExtensionInitializedEffect(() => {
    const cuid = pitcher.clients.fs.getIdFromPath(SANDBOX_CONFIG_FILE);

    if (!cuid) {
      return;
    }

    pitcher.clients.file.openFile(cuid).then((fileRef) => {
      try {
        const content = fileRef.object.content;

        if (typeof content === "string") {
          const jsonContent = JSON.parse(content);
          const shouldOpenTestDevtool = jsonContent.view === "tests";

          if (shouldOpenTestDevtool) {
            track("test_open_from_configfile");

            executeVSCodeCommand("codesandbox.openCsbTab", {
              type: "TESTS",
            });
          }

          fileRef.dispose();
        }
      } catch {
        // Silent fail
      }
    });
  }, []);

  return null;
};
